// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"y8-z"};